import { render } from "./StayToUpdated.vue?vue&type=template&id=c6b6c6e6"
import script from "./StayToUpdated.vue?vue&type=script&lang=js"
export * from "./StayToUpdated.vue?vue&type=script&lang=js"

import "./StayToUpdated.vue?vue&type=style&index=0&id=c6b6c6e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__